Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var reactStoreMaker = require('react-store-maker');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = "/**\n * Snippets from animate.css\n * Credit goes to https://github.com/daneden\n * github.com/daneden/animate.css\n*/\n.animate-module_animated__2-HnR {\n\t-webkit-animation-duration: 0.8192s;\n\tanimation-duration: 0.8192s;\n\t-webkit-animation-fill-mode: backwards;\n\tanimation-fill-mode: backwards;\n}\n\n/** fadeInRight */\n@-webkit-keyframes animate-module_fadeInRight__2zKA4 {\n\tfrom {\n\t\topacity: 0;\n\t\t-webkit-transform: translate3d(100%, 0, 0);\n\t\ttransform: translate3d(100%, 0, 0);\n\t}\n\n\tto {\n\t\topacity: 1;\n\t\t-webkit-transform: none;\n\t\ttransform: none;\n\t}\n}\n\n@keyframes animate-module_fadeInRight__2zKA4 {\n\tfrom {\n\t\topacity: 0;\n\t\t-webkit-transform: translate3d(100%, 0, 0);\n\t\ttransform: translate3d(100%, 0, 0);\n\t}\n\n\tto {\n\t\topacity: 1;\n\t\t-webkit-transform: none;\n\t\ttransform: none;\n\t}\n}\n\n.animate-module_fadeInRight__2zKA4 {\n\t-webkit-animation-name: animate-module_fadeInRight__2zKA4;\n\tanimation-name: animate-module_fadeInRight__2zKA4;\n}\n\n/** fadeInLeft */\n@-webkit-keyframes animate-module_fadeInLeft__1zEKa {\n\tfrom {\n\t\topacity: 0;\n\t\t-webkit-transform: translate3d(-100%, 0, 0);\n\t\ttransform: translate3d(-100%, 0, 0);\n\t}\n\n\tto {\n\t\topacity: 1;\n\t\t-webkit-transform: none;\n\t\ttransform: none;\n\t}\n}\n\n@keyframes animate-module_fadeInLeft__1zEKa {\n\tfrom {\n\t\topacity: 0;\n\t\t-webkit-transform: translate3d(-100%, 0, 0);\n\t\ttransform: translate3d(-100%, 0, 0);\n\t}\n\n\tto {\n\t\topacity: 1;\n\t\t-webkit-transform: none;\n\t\ttransform: none;\n\t}\n}\n\n.animate-module_fadeInLeft__1zEKa {\n\t-webkit-animation-name: animate-module_fadeInLeft__1zEKa;\n\tanimation-name: animate-module_fadeInLeft__1zEKa;\n}\n\n/** fadeOutRight */\n@-webkit-keyframes animate-module_fadeOutRight__1Tw3e {\n\tfrom {\n\t\topacity: 1;\n\t}\n\n\tto {\n\t\topacity: 0;\n\t\t-webkit-transform: translate3d(100%, 0, 0);\n\t\ttransform: translate3d(100%, 0, 0);\n\t}\n}\n\n@keyframes animate-module_fadeOutRight__1Tw3e {\n\tfrom {\n\t\topacity: 1;\n\t}\n\n\tto {\n\t\topacity: 0;\n\t\t-webkit-transform: translate3d(100%, 0, 0);\n\t\ttransform: translate3d(100%, 0, 0);\n\t}\n}\n\n.animate-module_fadeOutRight__1Tw3e {\n\t-webkit-animation-name: animate-module_fadeOutRight__1Tw3e;\n\tanimation-name: animate-module_fadeOutRight__1Tw3e;\n}\n\n/** fadeOutLeft */\n@-webkit-keyframes animate-module_fadeOutLeft__3MA_w {\n\tfrom {\n\t\topacity: 1;\n\t}\n\n\tto {\n\t\topacity: 0;\n\t\t-webkit-transform: translate3d(-100%, 0, 0);\n\t\ttransform: translate3d(-100%, 0, 0);\n\t}\n}\n\n@keyframes animate-module_fadeOutLeft__3MA_w {\n\tfrom {\n\t\topacity: 1;\n\t}\n\n\tto {\n\t\topacity: 0;\n\t\t-webkit-transform: translate3d(-100%, 0, 0);\n\t\ttransform: translate3d(-100%, 0, 0);\n\t}\n}\n\n.animate-module_fadeOutLeft__3MA_w {\n\t-webkit-animation-name: animate-module_fadeOutLeft__3MA_w;\n\tanimation-name: animate-module_fadeOutLeft__3MA_w;\n}\n";
var Animate = {
  "animated": "animate-module_animated__2-HnR",
  "fadeInRight": "animate-module_fadeInRight__2zKA4",
  "fadeInLeft": "animate-module_fadeInLeft__1zEKa",
  "fadeOutRight": "animate-module_fadeOutRight__1Tw3e",
  "fadeOutLeft": "animate-module_fadeOutLeft__3MA_w"
};
styleInject(css_248z$1);
var init = {
  activeStep: 1,
  transitions: {
    enterRight: Animate.animated + " " + Animate.fadeInRight,
    enterLeft: Animate.animated + " " + Animate.fadeInLeft,
    exitRight: Animate.animated + " " + Animate.fadeOutRight,
    exitLeft: Animate.animated + " " + Animate.fadeOutLeft
  },
  activeNamedStep: '__empty__',
  totalSteps: 0,
  classes: {},
  namedSteps: {},
  activatedSteps: {}
};

var reducer = function reducer(state, action) {
  return _assign(_assign({}, state), action);
};

var _a = reactStoreMaker.createStore(init, reducer, {
  providerName: 'StepMachine',
  useStoreName: 'useStepStore',
  useDispatchName: 'useStoreActions'
}),
    MachinePrivider = _a[0],
    useStepStore = _a[1],
    useStepDispatch = _a[2];

var StepPrivider = MachinePrivider;

var StepMiddleware = function StepMiddleware(props) {
  var transitions = props.transitions;
  var dispatch = useStepDispatch();
  React__namespace.useLayoutEffect(function () {
    if (transitions) {
      dispatch({
        transitions: transitions
      });
    }
  }, [dispatch, transitions]);
  return null;
};

var StepMachine = function StepMachine(props) {
  return React__namespace.createElement(StepPrivider, null, React__namespace.createElement(StepMiddleware, _assign({}, props)), props.children);
};

var css_248z = ".styles-module_step-wrapper__1Wt2o {\n\tposition: relative;\n}\n\n.styles-module_step__155rM {\n\topacity: 0;\n\tposition: absolute;\n\tpointer-events: none;\n\tz-index: 0;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n}\n\n.styles-module_active__3NUhU {\n\topacity: 1;\n\tposition: relative;\n\tpointer-events: inherit;\n\tz-index: 1;\n}\n";
var styles = {
  "step-wrapper": "styles-module_step-wrapper__1Wt2o",
  "step": "styles-module_step__155rM",
  "active": "styles-module_active__3NUhU"
};
styleInject(css_248z);

var useStep = function useStep(props) {
  var _a = useStepStore(),
      activeStep = _a.activeStep,
      classes = _a.classes;

  var isStepActive = React__namespace.useMemo(function () {
    return activeStep === props.order;
  }, [activeStep, props.order]);
  var transitions = React__namespace.useMemo(function () {
    return classes[props.order];
  }, [classes, props.order]);
  return {
    isStepActive: isStepActive,
    transitions: transitions
  };
};

var Step = function Step(_a) {
  var children = _a.children,
      rest = __rest(_a, ["children"]);

  var _b = useStep(rest),
      isStepActive = _b.isStepActive,
      transitions = _b.transitions;

  return React__namespace.createElement("div", {
    className: styles.step + " " + transitions + " " + (isStepActive ? styles.active : '')
  }, children);
};

var useStepActions = function useStepActions(props) {
  var _a = useStepStore(),
      activeStep = _a.activeStep,
      totalSteps = _a.totalSteps,
      classes = _a.classes,
      namedSteps = _a.namedSteps,
      activatedSteps = _a.activatedSteps,
      transitions = _a.transitions;

  var dispatch = useStepDispatch();
  var onStepChangeCbRef = React__namespace.useRef(props === null || props === void 0 ? void 0 : props.onStepChangeCb);
  onStepChangeCbRef.current = props === null || props === void 0 ? void 0 : props.onStepChangeCb;
  var isInvalidStep = React__namespace.useCallback(function (next) {
    return next < 1 || next > totalSteps;
  }, [totalSteps]);
  var setActiveStep = React__namespace.useCallback(function (next) {
    var _a;

    var _b;

    if (activeStep === next) return;
    if (isInvalidStep(next)) return;

    var classesCopy = _assign({}, classes);

    if (activeStep < next) {
      classesCopy[activeStep] = transitions.exitLeft;
      classesCopy[next] = transitions.enterRight;
    } else {
      classesCopy[activeStep] = transitions.exitRight;
      classesCopy[next] = transitions.enterLeft;
    }

    dispatch({
      classes: classesCopy,
      activeStep: next,
      activatedSteps: _assign(_assign({}, activatedSteps), (_a = {}, _a[next] = true, _a)),
      activeNamedStep: namedSteps[next]
    });
    (_b = onStepChangeCbRef.current) === null || _b === void 0 ? void 0 : _b.call(onStepChangeCbRef, activeStep + 1, next + 1);
  }, [activatedSteps, activeStep, classes, dispatch, isInvalidStep, namedSteps, transitions]);
  var goToNamedStep = React__namespace.useCallback(function (name) {
    if (!namedSteps[name]) return;
    var next = namedSteps[name];
    setActiveStep(next);
  }, [namedSteps, setActiveStep]);
  var goToStep = React__namespace.useCallback(function (order) {
    return setActiveStep(order);
  }, [setActiveStep]);
  var firstStep = React__namespace.useCallback(function () {
    return setActiveStep(1);
  }, [setActiveStep]);
  var lastStep = React__namespace.useCallback(function () {
    return setActiveStep(totalSteps);
  }, [totalSteps, setActiveStep]);
  var nextStep = React__namespace.useCallback(function () {
    return setActiveStep(activeStep + 1);
  }, [activeStep, setActiveStep]);
  var previousStep = React__namespace.useCallback(function () {
    return setActiveStep(activeStep - 1);
  }, [setActiveStep, activeStep]);
  return {
    goToNamedStep: goToNamedStep,
    goToStep: goToStep,
    firstStep: firstStep,
    lastStep: lastStep,
    nextStep: nextStep,
    previousStep: previousStep
  };
};

var StepContainer = function StepContainer(_a) {
  var children = _a.children,
      styles = _a.styles,
      initialStep = _a.initialStep,
      rest = __rest(_a, ["children", "styles", "initialStep"]);

  var dispatch = useStepDispatch();
  React__namespace.useLayoutEffect(function () {
    var _a;

    var _b, _c;

    var dispatchableObj = {};
    var couter = 0;
    React__namespace.Children.forEach(children, function (child) {
      var _a;

      var _b;

      var isStep = child.props.order !== undefined;

      if (isStep) {
        var order = child.props.order;
        couter++;
        dispatchableObj.namedSteps = _assign(_assign({}, dispatchableObj.namedSteps), (_a = {}, _a[order] = (_b = child.props.name) !== null && _b !== void 0 ? _b : "step-" + order, _a));
      }
    });
    dispatchableObj.activatedSteps = {
      1: true
    };
    dispatchableObj.activeNamedStep = (_b = dispatchableObj.namedSteps) === null || _b === void 0 ? void 0 : _b[1];

    if (initialStep) {
      dispatchableObj.activeStep = initialStep;
      dispatchableObj.activatedSteps = (_a = {}, _a[initialStep] = true, _a);
      dispatchableObj.activeNamedStep = (_c = dispatchableObj.namedSteps) === null || _c === void 0 ? void 0 : _c[initialStep];
    }

    dispatchableObj.totalSteps = couter;
    dispatch(dispatchableObj);
  }, []);
  return React__namespace.createElement("div", _assign({
    style: _assign({
      position: 'relative'
    }, styles)
  }, rest), children);
};

exports.Step = Step;
exports.StepContainer = StepContainer;
exports.StepMachine = StepMachine;
exports["default"] = StepMachine;
exports.useStepActions = useStepActions;
exports.useStepStore = useStepStore;